import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './shared';
import { authGuard, driverGuard } from './core';
import { superAdminGuard } from './core/super-admin.guard';
import { groupUserGuard } from './core/services/group-user.guard';
import { DeviceRedirectLink } from '@public/device-redirectLink/device-redirectLink.component';
import { ChangePasswordComponent } from '@public/change-password/change-password.component';
import { allRoleAccessGuard } from './core/auth-guard/auth.guard';
import { GenerateTruxLinkComponent } from '@public/generate-trux-link/generate-trux-link.component';
import { LandingV1Component } from '@public/landing-v1/landing-v1.component';
import { ParkingLotV1Component } from '@public/parking-lot-v1/parking-lot-v1.component';
import { DispatcherV1Component } from '@public/dispatcher-v1/dispatcher-v1.component';
import { DriverV1Component } from '@public/driver-v1/driver-v1.component';
import { HelpDeskComponent } from '@public/help-desk/help-desk.component';
import { TermsConditionComponent } from '@public/terms-condition/terms-condition.component';
import { WebTermsConditionsComponent } from '@public/web-terms-privacy/web-terms-conditions/web-terms-conditions.component';
import { PrivacyPolicyComponent } from '@public/privacy-policy/privacy-policy.component';
import { WebPrivacyPolicyComponent } from '@public/web-terms-privacy/web-privacy-policy/web-privacy-policy.component';
import { TruxLogin } from '@public/trux-login/trux-login.component';
import { mobilePageRedirectionComponent } from '@public/mobile-pageRedirection/mobile-pageRedirection.component';
import { DeviceDetectorComponentComponent } from '@public/device-detector-component/device-detector-component.component';
import { SurveyComponent } from '@public/survey/survey.component';
import { RedirectUrlAfterPaymentComponent } from '@public/redirect-url-after-payment/redirect-url-after-payment.component';
import { PaymentMethodAddedComponent } from '@shared/components/payment-method-added/payment-method-added.component';
import { BookingPaymentStatusComponent } from '@public/booking-payment-status/booking-payment-status.component';

const routes: Routes = [
  {
    path: '',
    component: LandingV1Component,
  },
  {
    path: 'parking-lot-manager',
    component: ParkingLotV1Component,
  },
  {
    path: 'group-operator',
    component: DispatcherV1Component,
  },
  {
    path: 'truck-driver',
    component: DriverV1Component,
  },
  {
    path: 'terms-of-service',
    component: TermsConditionComponent,
  },
  {
    path: 'terms-and-conditions',
    component: WebTermsConditionsComponent,
  },
  {
    path: 'help-desk',
    component: HelpDeskComponent,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'privacypolicy',
    component: WebPrivacyPolicyComponent,
  },
  {
    path: 'mobile',
    component: mobilePageRedirectionComponent,
  },
  {
    path:'gatelync-login',
    component:TruxLogin
  },
  {
    path: 'device-redirect',
    component: DeviceDetectorComponentComponent,
  },
  {
    path: 'redirection-payment/:id/:type/:role',
    component: RedirectUrlAfterPaymentComponent,
  },
  {
    path: 'booking-payment-status/:id/:roleEnum',
    component: BookingPaymentStatusComponent,
  },
  {
    path: 'booking-payment-status/:id',
    component: BookingPaymentStatusComponent,
  },
  {
    path: 'add-survey/:id',
    component: SurveyComponent
  },
  {
    path: 'guest',
    component: LayoutComponent,
    loadChildren: () =>
      import('./guestbooking/guestbooking.module').then(
        (g) => g.GuestbookingModule
      ),
  },
  {
    path: '',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    data: { title: 'authmodules', slug: 'authmodules' },
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [allRoleAccessGuard],
    data: { title: 'change-password', slug: 'change-password' },
  },
  {
    path: 'driver',
    component: LayoutComponent,
    loadChildren: () =>
      import('./modules/driver/driver.module').then((m) => m.DriverModule),
    canActivate: [driverGuard],
    data: { title: 'driver', slug: 'driver' },
  },
  {
    path: 'group-operator',
    component: LayoutComponent,
    loadChildren: () =>
      import('./modules/group-user/group-user.module').then((m) => m.GroupUserModule),
    canActivate: [groupUserGuard],
    data: { title: 'group-operator', slug: 'group-operator' },
  },
  {
    path: 'super-admin',
    component: LayoutComponent,
    canActivate: [superAdminGuard],
    loadChildren: () =>
      import('./modules/super-admin/super-admin.module').then(
        (m) => m.SuperAdminModule
      ),
    data: { title: 'super-admin', slug: 'super-admin' },
  },
  {
    path: 'create-booking-v1',
    component: LayoutComponent,
    loadChildren: () =>
      import('./shared/components/booking-flow-v1/booking-flow-v1.module').then(
        (m) => m.BookinFlowModuleV1
      ),
    data: { title: 'create-booking-v1', slug: 'create-booking-v1' },
  },
  {
    path: 'DeviceRedirectLink',
    component: DeviceRedirectLink,
  },
  {
    path: 'manager',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/manager/manager.module').then((m) => m.ManagerModule),
        canActivate: [authGuard],
        data: { title: 'manager', slug: 'manager' },
      },
    ],
  },
  {
    path: 'paymentMethodAdded',
    component: PaymentMethodAddedComponent,
    data: { title: 'paymentMethodAdded', slug: 'paymentMethodAdded' },
  },
  {
    path: 'gatetrux/:id',
    component: GenerateTruxLinkComponent,
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
